import React, { useState } from 'react';

import moment from "moment";

import classnames from 'classnames';

import { DropdownDate } from 'react-dropdown-date-3';


import {
  isAndroid,
  isIOS,
} from "react-device-detect";

// https://stackoverflow.com/questions/10193294/how-can-i-tell-if-a-browser-supports-input-type-date
// https://stackoverflow.com/questions/4159838/html5-type-detection-and-plugin-initialization
function checkDateInput() {

   // IE raises an exception if you try to set the type to
   // an invalid value, so we just swallow the error
  try {
    var input = document.createElement('input');
    input.setAttribute('type','date');

    var notADateValue = 'not-a-date';
    input.setAttribute('value', notADateValue);

    return (input.value !== notADateValue);
  } catch (e) {
    // do nothing
  }
}

function Date(props){

  const [date,setDate] = useState(moment());

  const handleDefaultDateChange = (event) => {
    let date = event.target.value;
    handleDateChange( date );
  };

  const handleDefaultDateBlur = (event) => {
    let date = event.target.value;
    handleDateChange( date );
  };

  const handleDateChange = (date) => {           // optional

    let mdate = moment( date );

    if( mdate.isValid() === true ){
      setDate(mdate);
      props.onDateChange( mdate );
    }
  };

  const handleDateBlur = (date) => {           // optional

    let mdate = moment( date );

    if( mdate.isValid() === false ){
      setDate(mdate);
      props.onDateChange( null );
    }
  };

  if( checkDateInput() === false || isAndroid || isIOS ){

    return (  <DropdownDate
                    startDate={'1801-01-01'}
                    endDate={'2100-12-31'}
                    selectedDate={date}

                    onDateChange={handleDateChange}

                    names={{
                            year: 'year',
                            month: 'month',
                            day: 'day'
                    }}
                    classes={{
                            dateContainer: 'd-inline-flex flex-row date-dd-form',

                            year: 'form-control form-control-lg',
                            month: 'form-control form-control-lg',
                            day: 'form-control form-control-lg',
                            yearContainer: 'date-dd-box',
                            monthContainer: 'date-dd-box',
                            dayContainer: 'date-dd-box',
                            //yearOptions: 'classes',
                            //monthOptions: 'classes',
                            //dayOptions: 'classes'
                    }}
                    defaultValues={                     // optional
                        {
                            year: 'select year',
                            month: 'select month',
                            day: 'select day'
                        }
                    }
                    options={                           // optional
                        {
                            monthShort: true,               // false by default
                        }
                    }
                />);

  // else if is mobile, set the date picker not to have the calendar
  }else{
    let classes = classnames(
      'form-control','form-control-lg','default-date-input',
      {
        'is-invalid': props.dateValidation,
      });

    return(<input
      className={classes}
      type="date"
      onChange={handleDefaultDateChange}
      onBlur={handleDefaultDateBlur}
      value={date.format('YYYY-MM-DD')}
      /> )
  }
}

export default Date;
